import { Button, Center, Stack, Text, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { Link, isRouteErrorResponse, useRouteError } from "react-router";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Center mih="60vh">
      <Stack align="center">
        <Title order={2}>{t("error.notFound")}</Title>
        <Button component={Link} to="/">
          {t("error.backHome")}
        </Button>
      </Stack>
    </Center>
  );
}

/** Chyba při vykreslení nebo načtení trasy; zobrazí se místo bílé obrazovky. */
export function RouteErrorPage() {
  const { t } = useTranslation();
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;

  return (
    <Center mih="60vh">
      <Stack align="center">
        <Text size="lg">{t("error.unexpected")}</Text>
        <Button onClick={() => window.location.reload()}>{t("common.reload")}</Button>
      </Stack>
    </Center>
  );
}
